<template v-if="property['IS_EMAIL']==='Y'">
  <div class="property-input property-item form-group row align-items-center">
    <label class="col-lg-3 col-form-label" :for="'ORDER_PROP_' + property.ID">
      <span>{{property['NAME']}}</span><span v-if="property['REQUIRED']==='Y'" class="color-dark-red">*</span>
    </label>
    <div class="col-lg-9">

      <input class="form-control" type="email" :name="'ORDER_PROP_' + property.ID" :readonly="readonly"
             :id="'ORDER_PROP_' + property.ID" :required="property.REQUIRED==='Y'" v-model="value">
    </div>
  </div>
</template>
<template v-else>
  <div class="property-input property-item form-group row align-items-center">
    <label class="col-lg-3 col-form-label" :for="'ORDER_PROP_' + property.ID">
      <span>{{property['NAME']}}</span><span v-if="property['REQUIRED']==='Y'" class="color-dark-red">*</span>
    </label>
    <div class="col-lg-9">

      <input  v-if="property['IS_EMAIL']==='Y'" class="form-control" type="email" :name="'ORDER_PROP_' + property.ID" :readonly="readonly"
             :id="'ORDER_PROP_' + property.ID" :required="property.REQUIRED==='Y'" v-model="value">
      <input  v-if="property['IS_EMAIL']!=='Y'" class="form-control" type="text" :name="'ORDER_PROP_' + property.ID" :readonly="readonly"
              :id="'ORDER_PROP_' + property.ID" :required="property.REQUIRED==='Y'" v-model="value">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'property-input',
    props: {
      property: {
        type: Object,
        required: true
      },
      initialValue: {
        type: [Number, String],
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      value: {
        get: function () {
          return this.initialValue
        },
        set: function (newValue) {
          this.$emit('update:value', newValue)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/order/components/PropertyInput.vue